// extracted by mini-css-extract-plugin
export default {"skeleton-textarea":"KL0G7"};